import React from "react";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";

const Content = ({heading, paragraph}) => {
  return (
    <Column spacing={"100"}>
      <Text type="h200">{heading}</Text>
      <Text type="b200">{paragraph}</Text>
    </Column>
  );
}

export default Content;